import { FlexRow } from "@/components/flex-row";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { AppLogo } from "@/components/app/app-logo";

function NavHeader() {
  return (
    <FlexRow className="group-data-[state=expanded]:p-2">
      <div className="flex items-center space-x-3 truncate group-data-[state=collapsed]:hidden">
        <AppLogo />

        <div className="flex flex-col">
          <span className="text-sm font-semibold text-gray-900">
            CAT / HRIN
          </span>
          <span className="text-xs text-gray-500">Gestion véhicules</span>
        </div>
      </div>

      <SidebarTrigger className="size-8" />
    </FlexRow>
  );
}

export { NavHeader };
